// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__NQcpz","inner":"Footer_inner__1bKZL","nextIcon":"Footer_nextIcon__11g9L","innerLeft":"Footer_innerLeft__3QiSj"};